(function () {

    angular
        .module('meanApp')
        .directive('richCard', ['$sce', '$filter', function ($sce, $filter) {
            return {
                restrict: 'EA',
                link: function (scope, element) {
                    scope.$watch('ld', function (val) {
                        var val = $sce.trustAsHtml($filter('json')(val));
                        if (val) {
                            element[0].outerHTML = '<script type="application/ld+json">'+ val + '</script>';
                        }
                        
                    });
                }
            };
        }]);
})();
